<template>
  <div style="max-width:1300px" class="mx-auto promillerechner">
    <div class="p-1">

      <drink v-for="(drink) in drinks"
             class="my-1"
             :key="drink.id"
             :drink="drink"
             @below-minimum-attempt="handleBelowMinimumAttempt($event, drink)"
             @changed="handleChangedDrinkQuantity($event, drink)"></drink>

      <div v-if="drinks.length === 0" class="p-2 bg-green-100">
        Klicke auf "Eigenes Getränk hinzufügen"
      </div>
      <span class="block my-4 text-center text-sm underline" @click="showAddDrink = !showAddDrink"
            v-if="!showAddDrink"><a>+ Eigenes Getränk hinzufügen</a></span>

      <div v-if="drinkToDelete" class="my-3 bg-red-100 py-2">
        <p class="font-bold text-center">Willst Du "{{ drinkToDelete.label }}" löschen?</p>

        <div class="flex justify-around mt-2">
          <div class="underline" @click="deleteDrink()">Ja, löschen</div>
          <div class="underline" @click="drinkToDelete = null">Nein</div>
        </div>
      </div>

    </div>

    <transition name="fade">
      <div v-if="showAddDrink" class="bg-gray-100 p-3 m-6" style="box-shadow: 10px 10px 5px gray">
        <span class="font-bold mb-2 block mt-2 text-xl text-center">Eigenes Getränk hinzufügen</span>

        <div class="flex flex-wrap p-1 justify-between">
          <div class="w-full sm:w-full md:w-full my-2 box-border px-1">
            <label class="font-bold" for="drink_label">Bezeichnung</label><br>
            <input class="w-full p-1 mt-2" v-model="customDrink.label" id="drink_label" type="text"
                   placeholder="z.B. Gin-Tonic">
          </div>

          <div class="w-full sm:w-1/2 md:w-1/2 my-2 box-border px-1">
            <label class="font-bold" for="drink_vol">Akoholgehalt in %</label><br>
            <input style="width: 100px" class="p-1 mt-2" v-model="customDrink.vol" id="drink_vol" type="number">%
          </div>

          <div class="w-full sm:w-1/2 md:w-1/2 my-2 box-border px-1">
            <label class="font-bold" for="drink_size">Getränkemenge/Glas</label><br>
            <input style="width: 100px" class="p-1 mt-2" id="drink_size" v-model="customDrink.size" type="number">
            <select class="p-1" v-model="customDrink.unit">
              <option value="ml">Milliliter (ml)</option>
              <option value="cl">Centiliter (cl)</option>
              <option value="l">Liter (l)</option>
            </select>
          </div>

          <div class="w-full flex flex-wrap justify-center align-middle mt-4">
            <div class="add-custom-drink box-border p-2 mx-1" @click="addCustomDrink">
              Getränk hinzufügen
            </div>

            <div @click="showAddDrink = false" class="p-2 box-border underline">Abbrechen</div>
          </div>

        </div>

      </div>
    </transition>

    <div class="w-full flex flex-wrap box-border p-1">

      <div @click="setGender('m')"
           class="hover:bg-gray-200 gender-selection box-border rounded-br-2xl rounded-tr-2xl  p-2 text-center w-1/5"
           v-bind:class="{'active' : gender === 'm' }">
        <img style="max-width:20px; margin:0px auto" :src="require('@/assets/male.png')">
      </div>

      <div class="box-border text-center w-3/5">
        <div class="mx-auto">
          <span class="text-3xl">{{ gender === 'm' ? 'Mann' : 'Frau' }}</span>
          <span class="block text-gray-400 text-xs">Geschlecht</span>
        </div>

      </div>

      <div @click="setGender('w')"
           class="hover:bg-gray-200 gender-selection box-border  rounded-bl-2xl rounded-tl-2xl  p-2 text-center w-1/5"
           :class="{'active' : gender === 'w' }">
        <img style="max-width:20px; margin:0px auto" :src="require('@/assets/female.png')">
      </div>

    </div>

    <div class="p-1">
      <counter :config="{min:30, max:300, start:this.weight, stepSize:1, label:'Gewicht', directInput:false}"
               @incremented="handleWeightChange"
               @decremented="handleWeightChange">
        <template v-slot:after-value>
          <span class="mx-1 block">kg</span>
        </template>
      </counter>
    </div>

    <div class="bg-gray-100 mt-2 w-full sm:w-1/2 mx-auto text-center">
      <div class="font-bold text-3xl py-2 px-2">
        <span class="text-xl">Dein Blutalkoholgehalt</span>
        <div class="w-full my-2 inline-block">
          {{ animatedPromille }} <span class="text-xl">‰</span>
        </div>

      </div>
      <div class="text-sm pb-2">
        Es dauert ca. {{ times.toZero5 }} Stunden, bis Dein Blutakoholgehalt kleiner 0.5 Promille ist. <br>In etwa
        {{ times.toSober }} Stunden hast Du 0,0 Promille.<br>
        <span class="text-xs">Konsumierte Alkoholmenge: {{ animatedTotalAlc }} Gramm</span>
        <span class="hidden"> {{ calculations.totalAlc }}</span><br>
        <a class="underline" @click="initialize">Zurücksetzen</a>

      </div>
    </div>
  </div>


</template>

<script>

import Drink from "./components/drink";
import Counter from './components/counter'

import gsap from 'gsap'
import {nextTick} from 'vue'

export default {
  name: 'App',
  components: {
    Drink,
    Counter
  },

  computed: {

    animatedPromille() {
      return this.tweenedPromille.toFixed(2)
    },

    animatedTotalAlc() {
      return this.tweenedTotalAlc.toFixed(2)
    },

    times() {
      let toSober = null;
      let toZero5 = null;
      let hours = 0;
      let promille = this.calculations.promille;

      const reducePromille = (currentPromille) => {
        return currentPromille - 0.13;
      }

      while (promille > 0) {

        //special case: if we have a initial promille value < 0.5 we are below the level immediately,
        //so before our first actual reduction we need to take this result
        if (hours === 0 && promille < 0.5) {
          toZero5 = 0;
        }

        hours++;
        promille = reducePromille(promille);

        //first time we reach a level below .5
        if ((promille < 0.5) && toZero5 === null) {
          toZero5 = hours;
        }

        if (promille < 0) {
          toSober = hours;
        }
        else {
          toSober = hours;
        }
      }

      return {toSober: toSober, toZero5: toZero5};

    },

    calculations() {

      //BAK (in Promille) = A / (p * r)
      /*
      A =	aufgenommener Alkohol in Gramm
    	p =	Körpergewicht in Kilogramm
 	    r =	Reduktionsfaktor, der beim Mann 0,7 und bei der Frau 0,6 beträgt.
       */

      let totalAlc = 0;
      let promille = 0;

      //gender dependent
      let reductionFactor = this.gender === 'm' ? 0.7 : 0.6;

      this.drinks.forEach((drink) => {
        /*
          Alkoholgehalt (in Gramm reiner Alkohol) = Menge des Getränks (in ml)  x  (Vol.-% / 100)  x  0,8
        */
        totalAlc = totalAlc + (drink.quantity * (this.convertToMilliliter(drink.size, drink.unit) * (drink.vol / 100) * 0.8));
      });

      promille = totalAlc / (this.weight * reductionFactor);

      gsap.to(this.$data, {duration: 0.5, tweenedPromille: promille})
      gsap.to(this.$data, {duration: 0.5, tweenedTotalAlc: totalAlc})

      return {totalAlc: totalAlc.toFixed(1), promille: promille.toFixed(2)};

    }
  },

  data() {
    return {
      drinks: [],
      showAddDrink: false,
      customDrink: this.getDefaultCustomDrink(),
      gender: 'm',
      weight: 80,
      drinkToDelete: null,
      tweenedPromille: 0,
      tweenedTotalAlc: 0
    }
  },

  created() {
    this.initialize()
  },

  methods: {

    async initialize() {

      this.drinks = [];

      await nextTick();
      this.drinks.push(this.generateDrinkConfig('Kl. Bier', 330, 'ml', 4.8, 0, 'beer_glass_small.png'));
      this.drinks.push(this.generateDrinkConfig('Gr. Bier', 500, 'ml', 4.8, 0, 'beer_glass_large.png'));
      this.drinks.push(this.generateDrinkConfig('Wein', 250, 'ml', 11.0, 0, 'wine_glass.png'));
      this.drinks.push(this.generateDrinkConfig('Shot', 2, 'cl', 40.0, 0, 'shot_glass.png'));


    },

    deleteDrink() {
      this.drinks.forEach((drink, index) => {
        if (drink === this.drinkToDelete) {
          console.log("deleting index " + index);
          this.drinks.splice(index, 1);
          this.drinkToDelete = null;
        }
      })
    },

    setGender(gender) {
      this.gender = gender;
    },

    handleBelowMinimumAttempt(event, drink) {
      this.drinkToDelete = drink;
    },

    handleChangedDrinkQuantity(quantity, drink) {
      drink.quantity = quantity;
    },

    handleWeightChange(value) {
      this.weight = value;
    },

    convertToMilliliter(amount, unit) {
      switch (unit) {
        case 'ml':
          return amount;
        case 'cl':
          return amount * 10;
        case 'l':
          return amount * 1000;
      }
    },

    addCustomDrink() {
      this.drinks.push(this.customDrink);
      this.resetCustomDrink();
      this.showAddDrink = false;
    },

    resetCustomDrink() {
      this.customDrink = this.getDefaultCustomDrink();
    },

    getDefaultCustomDrink() {
      return this.generateDrinkConfig('Eigenes Getränk', 250, 'ml', 12, 1);
    },

    generateDrinkConfig(label = 'Drink', size = 250, unit = 'ml', vol = 12, quantity = 0, icon = 'shot_glass.png') {
      return {
        label: label,
        size: size,
        unit: unit,
        vol: vol,
        quantity: quantity,
        id: "id" + Math.random(),
        icon: icon
      }
    }
  }
}
</script>

<style>

.active {
  background-color: #efefef;
  border: 3px solid #323232 !important;
}

.gender-selection {
  border: 1px solid grey;
  font-size: 20px;
  font-weight: 800;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}

.add-custom-drink {
  background-color: #6597d1;
  color: white;

  padding: 10px 25px;
}
</style>
